import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { normalizeRole } from '../utils/userLocale';
import { tenantMayAccessPage } from '../utils/tenantModules';
import './AccessRestrictedPage.css';

const AccessRestrictedPage = ({ onNavigate, pageKey, user, reason }) => {
  const { t } = useLanguage();
  const role = normalizeRole(user?.role);
  const isOwner = role === 'owner';

  let title = t('access.title');
  let body = null;

  if (reason === 'module' || (user && pageKey && !tenantMayAccessPage(pageKey, user))) {
    title = 'Feature not enabled';
    body = (
      <>
        {isOwner ? (
          <>
            This feature is not available for your business type or plan. If you need it, contact support or check{' '}
            <strong>Settings → Billing</strong>.
          </>
        ) : (
          <>
            This feature is not enabled for your workspace. Ask your owner or contact support.
          </>
        )}
      </>
    );
  } else if (reason === 'role' || !isOwner) {
    body = <>{t('access.ownerOnly')}</>;
  } else {
    body = (
      <>
        You do not have permission to open this page. If you are the owner, try signing out and back in, or contact
        support.
      </>
    );
  }

  return (
    <div className="page-bleed">
      <div className="access-restricted-root">
        <h1>{title}</h1>
        <p>{body}</p>
        <div className="access-restricted-actions">
          <button type="button" className="access-restricted-btn" onClick={() => onNavigate('overview')}>
            {t('access.back')}
          </button>
          {isOwner && (
            <button
              type="button"
              className="access-restricted-btn access-restricted-btn--ghost"
              onClick={() => onNavigate('subscription')}
            >
              Billing &amp; plans
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AccessRestrictedPage;
